import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { DialogEnum, useDialog } from "../contexts/DialogContext";
import { RoutePaths } from "../routes";
const DesktopNav = () => {
  const location = useLocation();
  const auth = useAuth();
  const dialog = useDialog();
  const elections = [
    { name: "General", path: RoutePaths.GENERAL_ELECTIONS },
    { name: "Partisan", path: RoutePaths.PARTISAN_ELECTIONS },
    { name: "Non-Partisan", path: RoutePaths.NON_PARTISAN_ELECTIONS },
    { name: "Presidential", path: RoutePaths.PRESIDENTIAL_ELECTIONS },
  ];
  return (
    <>
      <div className="hidden lg:block">
        <div className="flex items-center justify-between px-12 py-6">
          <div className="pl-4">
            <Link to={RoutePaths.LANDING}>
              <img src="/logo-2.png" alt="ballot chart logo" />
            </Link>
          </div>
          <div className="flex justify-between">
            {auth.isLoggedIn ? (
              auth.isAdmin ? (
                <>
                  <div className="px-6">
                    <Menu as="div" className="relative inline-block text-left">
                      <div>
                        <Menu.Button
                          className={`${location.pathname.startsWith(
                            RoutePaths.GENERAL_ELECTIONS
                          ) ||
                            location.pathname.startsWith(
                              RoutePaths.PARTISAN_ELECTIONS
                            ) ||
                            location.pathname.startsWith(
                              RoutePaths.NON_PARTISAN_ELECTIONS
                            ) ||
                            location.pathname.startsWith(
                              RoutePaths.PRESIDENTIAL_ELECTIONS
                            )
                            ? "border-b border-red-500"
                            : ""
                            }`}
                        >
                          ELECTIONS
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-white shadow-md">
                          <div className="px-1 py-1 ">
                            {elections.map((election) => (
                              <Menu.Item key={`e-${election.name}`}>
                                {({ active }) => (
                                  <Link
                                    to={election.path}
                                    className="flex items-center w-full px-2 py-2 text-sm group"
                                  >
                                    <span
                                      className={`${active
                                        ? "border-b border-red-500"
                                        : "text-gray-900 border-b border-transparent"
                                        }`}
                                    >
                                      {election.name}
                                    </span>
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                  <div className="px-6">
                    <Link
                      to={RoutePaths.RULE_SETS}
                      className={`${location.pathname.startsWith(RoutePaths.RULE_SETS)
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      RULE SETS
                    </Link>
                  </div>
                  <div className="px-6">
                    <Link
                      to="/rules"
                      className={`${location.pathname.startsWith("/rules") &&
                        !location.pathname.includes(RoutePaths.RULE_SETS)
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      RULES
                    </Link>
                  </div>
                  <div className="px-6">
                    <Link
                      to="/clerks"
                      className={`${location.pathname.startsWith("/clerk")
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      CLERKS
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <div className="px-6">
                    <Link
                      to={RoutePaths.NON_PARTISAN_CHARTS}
                      className={`flex flex-col ${location.pathname.startsWith(
                        RoutePaths.NON_PARTISAN_CHARTS
                      )
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      <div>NON-PARTISAN /</div>
                      <div>PRESIDENTIAL PRIMARY</div>
                    </Link>
                  </div>
                  <div className="px-6">
                    <Link
                      to={RoutePaths.GENERAL_CHARTS}
                      className={`${location.pathname.startsWith(RoutePaths.GENERAL_CHARTS)
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      GENERAL
                    </Link>
                  </div>
                  <div className="px-6">
                    <Link
                      to={RoutePaths.PARTISAN_CHARTS}
                      className={`${location.pathname.startsWith(RoutePaths.PARTISAN_CHARTS)
                        ? "border-b border-red-500"
                        : ""
                        }`}
                    >
                      PARTISAN PRIMARY
                    </Link>
                  </div>
                  {/*<div className="px-6">
                    <Link
                      to={RoutePaths.PRESIDENTIAL_CHARTS}
                      className={`${location.pathname.startsWith(
                        RoutePaths.PRESIDENTIAL_CHARTS
                      )
                          ? "border-b border-red-500"
                          : ""
                        }`}
                    >
                      PRESIDENTIAL PRIMARY
                    </Link>
                      </div>*/}
                </>
              )
            ) : (
              <>
                <button
                  className="px-5 py-3 mr-5 tracking-wider text-blue-800 uppercase transition outline-none hover:text-blue-900"
                  onClick={() => dialog.push(DialogEnum.SIGN_IN)}
                >
                  Log In
                </button>
                <a
                  className="px-5 py-3 font-semibold tracking-wider text-white uppercase transition bg-blue-800 rounded-md hover:bg-blue-900"
                  href={RoutePaths.CREATE_ACCOUNT}
                >
                  Sign Up
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopNav;
